import { FC, ReactNode } from "react";

import { Translate } from "@/app/application/Translate";
import { SaveActionButton } from "@/shared/ui";

interface CustomSaveButtonProps {
	disabled?: boolean;
	loading?: boolean;
	textOverride?: ReactNode;
}
export const CustomSaveButton: FC<CustomSaveButtonProps> = (props) => {
	return (
		<SaveActionButton
			autoFocus
			value="Save"
			loading={props.loading}
			loadingText={<Translate String="LabDaily.Saving">Saving...</Translate>}
			disabled={props.disabled}
		>
			{props.textOverride ?? (
				<Translate String="Training.Common.Button.Save">Save</Translate>
			)}
		</SaveActionButton>
	);
};
